/**
 * Standard UI size tokens used across components and configuration objects.
 */
export enum SizeRange {
    mini = 'mini',
    compact = 'compact',
    regular = 'regular',
    large = 'large',
    huge = 'huge',
    giant = 'giant',
}

/**
 * Options for circular timers/indicators.
 * Used by toast timer settings.
 */
export interface CircleOptionsI {
    /** Circle radius in pixels. */
    radius: number;
}

/**
 * Time units used for timer configuration.
 */
export enum TimeUnits {
    /** Hours. */
    hh = 'hh',
    /** Minutes. */
    mm = 'mm',
    /** Seconds. */
    ss = 'ss',
    /** Milliseconds. */
    ms = 'ms',
}
